import { combineReducers } from "redux";

import { ILine, LineID } from "../api/APIClient";
import { RootAction } from "../types";
import APIError from "src/api/APIError";

function data(state: ILine[] = [], action: RootAction): ILine[] {
  switch (action.type) {
    case "FETCH_LINES_SUCCESS":
      return action.payload;

    case "UPDATE_LINE_SUCCESS":
    case "CREATE_LINE_SUCCESS":
      let lines = [...state];
      const line = action.payload;
      const idx = lines.findIndex(l => l.id === line.id);
      if (idx >= 0) {
        lines[idx] = line;
      } else {
        lines = [line, ...lines];
      }
      return lines;

    case "DELETE_LINE_SUCCESS":
      const deletedID = action.payload.id;
      return state.filter(l => l.id !== deletedID);

    default:
      return state;
  }
}

function modalOpen(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "TOGGLE_LINE_MODAL":
      return !state;
    case "SHOW_CREATE_LINE":
      return true;
    case "SHOW_EDIT_LINE":
      return true;
    case "UPDATE_LINE_SUCCESS":
    case "CREATE_LINE_SUCCESS":
    case "DELETE_LINE_SUCCESS":
      return false;
    default:
      return state;
  }
}

function selectedID(
  state: LineID | null = null,
  action: RootAction
): LineID | null {
  switch (action.type) {
    case "SHOW_CREATE_LINE":
      return null;
    case "SHOW_EDIT_LINE":
      return action.payload;
    case "UPDATE_LINE_SUCCESS":
    case "CREATE_LINE_SUCCESS":
      return null;
    default:
      return state;
  }
}

function isLoading(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "CREATE_LINE_REQUEST":
    case "UPDATE_LINE_REQUEST":
      return true;
    case "UPDATE_LINE_SUCCESS":
    case "UPDATE_LINE_FAILURE":
    case "CREATE_LINE_SUCCESS":
    case "CREATE_LINE_FAILURE":
      return false;
    default:
      return state;
  }
}

function error(
  state: APIError | null = null,
  action: RootAction
): APIError | null {
  switch (action.type) {
    case "UPDATE_LINE_REQUEST":
    case "UPDATE_LINE_SUCCESS":
      return null;
    case "UPDATE_LINE_FAILURE":
    case "CREATE_LINE_FAILURE":
    case "DELETE_LINE_FAILURE":
      return action.payload;
    default:
      return state;
  }
}

export const linesReducer = combineReducers({
  data,
  modalOpen,
  selectedID,
  isLoading,
  error,
});
export default linesReducer;



// WEBPACK FOOTER //
// ./src/reducers/linesReducer.ts